import { render, staticRenderFns } from "./NameBoard.vue?vue&type=template&id=594721b3"
import script from "./NameBoard.vue?vue&type=script&lang=js"
export * from "./NameBoard.vue?vue&type=script&lang=js"
import style0 from "./NameBoard.vue?vue&type=style&index=0&id=594721b3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports